import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { ChevronLeftIcon, UploadIcon } from "@gemini/icons";
import { FavoriteHeart } from "@seeker-consumer-portal/favorite-heart";
import { TopBarCTA } from "./TopBarCTA";
import { useI18n } from "@/contexts/i18n";
import { useTestId, useBackNavigation, useShare, useFavoriteTracking, useFeatureEnabled, } from "@/hooks";
import { useClassifiedId } from "@/contexts/classified";
import { useRefsContext } from "@/contexts/ref";
import { useConfig } from "@/contexts/cdpConfig";
export const TopBar = () => {
    const { mobilePreview: { inView }, } = useRefsContext();
    const classifiedId = useClassifiedId();
    const { nativeMobileShare } = useShare();
    const backNavigation = useBackNavigation();
    const favoriteTracking = useFavoriteTracking();
    const favoriteEnabled = useFeatureEnabled("favorites");
    const isPreviewMode = useConfig().previewMode;
    const testId = useTestId(inView ? "InvisibleTopBar👻" : "TopBar");
    const { t } = useI18n();
    return (_jsxs(Box, { position: inView ? "absolute" : "fixed", top: inView ? "initial" : "0px", display: {
            "breakpoint.base": "flex",
            "breakpoint.lg": "none",
        }, gridColumn: {
            "breakpoint.base": "col-start / span 4",
            "breakpoint.sm": "col-start / span 8",
            "breakpoint.xl": "col-start 2 / span 10",
            "breakpoint.xxxl": "col-start 3 / span 8",
        }, borderBottomWidth: inView ? "borderWidth.none" : "borderWidth.1", borderBottomColor: inView
            ? "color.surface.transparent.default"
            : "unsafe_component.topBar.color.border", borderBottomStyle: inView ? "none" : "solid", paddingHorizontal: "spacing.16", paddingVertical: "spacing.12", backgroundColor: inView ? "inherit" : "color.border.constant.white", width: "100%", zIndex: inView ? "zIndex.1" : "zIndex.3", transitionDuration: "motionDuration.300", testId: testId, justifyContent: "space-between", unsafe_className: "HideOnPrint", children: [_jsx(TopBarCTA, { isOver: inView, icon: ChevronLeftIcon, label: t("common.CTA.back.label"), onPress: backNavigation }), _jsxs(Box, { display: inView ? "none" : "flex", width: favoriteEnabled ? "sizing.80" : "sizing.40", justifyContent: "space-between", children: [_jsx(TopBarCTA, { isOver: inView, icon: UploadIcon, label: t("common.CTA.share.label"), onPress: nativeMobileShare }), !isPreviewMode && (_jsx(FavoriteHeart, { classifiedId: classifiedId, tracking: favoriteTracking, small: true }))] })] }));
};
